<template>
  <div>
    <div>
      <router-link to="/">Home </router-link>
      <label class="labelBar"> / </label>
      <router-link to="/usuario"> Usuário </router-link>
      <label class="labelBar"> / </label>
      <label> Criar</label>
    </div>
    <tab-navegacao />
    <v-container fluid>
      <avatar
        style="position: relative; width: 40%; left: 60%"
        ref="avatar"
        :title="title"
        :isAllowed="true"
      />
      <v-form ref="form" v-model="valid" lazy-validation>
        <formulario
          ref="formulario"
          :perfis="filteredPerfil"
          :departamentos="departamentos"
          :cargos="filteredCargo"
          :permissoes="filteredPermissoes"
          :unidadesAdm="filteredUndAdm"
        />
      </v-form>
      <v-row align="center-left">
        <v-col class="text-right">
          <v-btn to="/usuario" color="error" class="mr-4"> Voltar </v-btn>
          <v-btn @click="enviar" color="success" class="mr-4"> Salvar </v-btn>
        </v-col>
      </v-row>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-container>
  </div>
</template>

<script>
import { enviarUsuarioAsync } from "../../../services/usuarioService";
import { mapState } from "vuex";
import Formulario from "./Formulario";
import Avatar from "../../Avatar/AvatarCard";
import TabNavegacao from "../../Tabs/TabCadastroUsuario";

export default {
  name: "criarUsuario",
  data: () => ({
    overlay: false,
    valid: true,
    title: "Foto de Perfil",
  }),
  computed: {
    ...mapState("departamento", ["departamentos"]),
    ...mapState("cargo", ["cargos"]),
    ...mapState("perfil", ["perfis"]),
    ...mapState("local", ["locais"]),
    ...mapState("permissao", ["permissoes"]),

    filteredCargo() {
      return this.cargos.filter((c) => {
        return c.ativo === true;
      });
    },
    filteredPerfil() {
      return this.perfis.filter((p) => {
        return p.ativo === true;
      });
    },
    filteredUndAdm() {
      const tipos = [2, 3];
      return this.locais.filter((u) => {
        return (u.ativo === true && tipos.includes(u.idTipoLocais));
      });
    },
    filteredPermissoes() {
      return this.permissoes.filter((p) => {
        return p.ativo === true;
      });
    },
  },
  methods: {
    async enviar() {
      if (this.$refs.form.validate()) {
        this.overlay = true;
        var img = this.$refs.avatar.getImg();
        const resposta = await enviarUsuarioAsync(
          this.$refs.formulario.nome,
          this.$refs.formulario.email,
          this.$refs.formulario.telefone,
          this.$refs.formulario.matricula,
          this.$refs.formulario.cargoSelected.id,
          this.$refs.formulario.perfilSelected.id,
          this.$refs.formulario.unidadeAdmSelected.map((a) => a.id),
          this.$refs.formulario.usuarioDepartamentosPayload,
          //this.$refs.formulario.departamentoSelected.map((a) => a.id),
          img
        );
        if (resposta) {
          //this.mensagemErro = resposta;
          //this.mostartMensagemErro = true;
          this.overlay = false;
          this.$alert(resposta.message, "Descupe, falha na operação!", "error");
        } else {
          this.overlay = false;
          this.$router.push("/usuario");
        }
      }
    },
  },
  components: {
    Formulario,
    Avatar,
    TabNavegacao,
  },
};
</script>
